
import React from "react";
import { Form, Label, Select } from "semantic-ui-react";

const SelectInput = ({
  input,
  //type,
  placeholder,
  multiple,
  search,
  options,
  disabled,
  meta: { touched, error }
}) => {
  const val= (multiple)? []:null
  return (
    <Form.Field error={touched && !!error}>
      <Select
      {...input}
       onBlur={() => input.onBlur()}
        disabled={disabled}
        value={input.value || val }
        onChange={(e, data) => input.onChange(data.value)}
        placeholder={placeholder}
        options={options}
        multiple={multiple}
        search={search}
      />
      {touched &&
        error && (
          <Label basic color="red">
            {error}
          </Label>
        )}
    </Form.Field>
  );
};

export default SelectInput;
